module.exports = " <div class=message> <h2>留言板</h2> <p>评论、吐槽都在这，欢迎盖楼</p> </div> <span @click=reload() class=\"icon icon-refresh\"></span> <div class=ds-thread data-thread-key=message data-title=vue_jd&message data-url=http://seaman-7.github.io/message></div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.4/vue-loader/lib/selector.js?type=template&index=0!./src/components/Message.vue
 ** module id = 19
 ** module chunks = 1
 **/